module.exports = __webpack_public_path__ + "img/repic.aaa1bed9.jpg";